class LongTouch {
  constructor(vue) {
    this.vue = vue
  }

  install() {
    let timeOutEvent = null
    this.vue.directive('longTouch', {
      // 当被绑定的元素插入到 DOM 中时执行
      bind(el, binding) {
        // 聚焦元素
        el.addEventListener(
          'touchstart',
          (e) => {
            clearTimeout(timeOutEvent) // 清除定时器
            timeOutEvent = null
            timeOutEvent = setTimeout(() => {
              //  执行长按要执行的内容
              binding.value(e)
            }, 600)
          },
          false
        )
        el.addEventListener(
          'touchmove',
          () => {
            clearTimeout(timeOutEvent) // 清除定时器
            timeOutEvent = null
          },
          false
        )
        el.addEventListener(
          'touchend',
          () => {
            clearTimeout(timeOutEvent)
            if (!timeOutEvent) {
              //  这里写要执行的内容（尤如onclick事件）
            }
          },
          false
        )
      }
    })
  }
}

export default LongTouch
